import { Skeleton } from "@mui/material";

interface Props {}

export default function ClientOrderReportDrawerSkeletonUI(props: Props) {
	return (
		<div>
			<div
				style={{
					marginTop: "10px",
					display: "flex",
					flexDirection: "column",
					gap: "15px",
				}}
			>
				<div>
					<div style={{ marginBottom: "10px" }}>
						<Skeleton
							variant="rectangular"
							width={"40%"}
							height={24}
							sx={{ borderRadius: "4px" }}
						/>
					</div>
					<div className="client-view-test-report-card-radio-group">
						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={140}
							sx={{ borderRadius: "14px" }}
						/>
						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={140}
							sx={{ borderRadius: "14px" }}
						/>{" "}
						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={140}
							sx={{ borderRadius: "14px" }}
						/>
					</div>
				</div>
				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={400}
					sx={{ borderRadius: "14px" }}
				/>
			</div>
		</div>
	);
}
